"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleCharts = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const baseLibrary_1 = require("../baseLibrary");
class MbGoogleCharts extends baseLibrary_1.BaseLibrary {
    async load() {
        this.instance = new web_ui_framework_1.GoogleCharts();
        await this.instance.load();
    }
}
const GoogleCharts = new MbGoogleCharts();
exports.GoogleCharts = GoogleCharts;
//# sourceMappingURL=index.js.map